import React from "react";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { BsFillShareFill } from "react-icons/bs";
import { updateUserProfile, getProfileData } from "../../services/authSlice";
import app from "../../services/firebaseinit";
import GithubStats from "./GithubStats";

const db = getFirestore(app);

const usersDb = "users";
const Input = ({ placeholder, name, type, value, handleChange }) => (
  <input
    placeholder={placeholder}
    type={type}
    step="0.0001"
    value={value}
    onChange={(e) => handleChange(e, name)}
    className="my-2 w-full rounded-sm p-2 outline-none bg-transparent text-white border-none text-sm white-glassmorphism"
  />
);
const Profile = () => {
  const dispatch = useDispatch();
  const { currentUser, uid, profile } = useSelector((state) => state.auth);
  const [githubusername, setGithubusername] = React.useState("");
  const [linkedinusername, setLinkedinusername] = React.useState("");

  const hundleSubmit = (e) => {
    e.preventDefault();
    const data = {
      githubusername,
      linkedinusername,
    };
    console.log(data);
    dispatch(updateUserProfile(data));
  };
  const copyLink = () => {
    const el = document.createElement("input");
    el.value = `https://${window.location.hostname}/portfoliax/share/${currentUser.uid}`;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    alert("Link Copied");
  };

  const getUserP = () => {
    if (uid !== "") {
      onSnapshot(doc(db, usersDb, currentUser.uid), (docucment) => {
        dispatch(getProfileData(docucment.data()));
      });
    }
  };
  React.useEffect(() => {
    getUserP();
  }, [0]);
  console.log(uid);
  return (
    uid === "" ? (<Navigate to="/portfoliax" />) :
      (
        <div>
          <div className="flex w-full justify-center items-center">
            <div className="flex mf:flex-row flex-col items-start justify-between md:p-20 py-12 px-4">
              <div className="flex flex-1 justify-start items-start flex-col mf:mr-10">
                <h1 className="text-3xl sm:text-5xs text-white text-gradient py-1">
                  {!profile && "Update Your Profile"} {currentUser && currentUser?.displayName?.toUpperCase()}
                </h1>
                <p className="text-left mt-5 text-white font-light md:w-9/12 w-11/12 text-base">
                  <Link to="/user/video" className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#2546bd]">
                    Video Upload Dashboard
                  </Link>
                </p>
                <p className="p-4">
                  {profile && (
                    <>
                      <img className="w-full" src={`https://activity-graph.herokuapp.com/graph?username=${profile.githubusername}&theme=dracula&color=B994E6&bg_color=2B2D3D`} />
                      <img src="https://capsule-render.vercel.app/api?type=waving&color=gradient&height=60&section=footer" />
                      <p className="text-3xl sm:text-5xs text-white text-gradient py-1">Your Visitor Count On Github</p>
                      <img height="20vh" src={`https://profile-counter.glitch.me/${profile.githubusername}/count.svg`} />
                    </>
                  )}
                </p>
              </div>
              <div className="flex flex-col flex-1 items-center justify-start w-full mf:mt-0 mt-10">
                <div className="p-3 flex justify-end items-start flex-col rounded-xl h-40 sm:w-72 w-full my-4 eth-card .white-glassmorphism ">
                  <div className="flex justify-between flex-col w-full h-full">
                    <div className="flex justify-between items-start">
                      <div className="w-10 h-10 rounded-full border-2 border-white flex justify-center items-center">
                        {currentUser && <img src={currentUser.photoURL} alt="" style={{ height: "35px", width: "35px", borderRadius: "50%" }} />}
                      </div>
                      <BsFillShareFill fontSize={17} color="#fff" onClick={copyLink} />
                    </div>
                    <div>
                      <p className="text-white font-light text-sm">
                        {currentUser && uid?.toUpperCase()}
                      </p>
                      <p className="text-white font-semibold text-lg mt-1">
                        {currentUser && currentUser?.displayName?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-5 sm:w-96 w-full flex flex-col justify-start items-center blue-glassmorphism">
                  <p className="text-left text-white font-bold md:w-full w-full text-base">{profile && profile.githubusername}</p>
                  <Input placeholder="Enter Github username" name="githubusername" type="text" handleChange={(e) => setGithubusername(e.target.value)} />
                  <p className="text-left text-white font-bold md:w-full w-full text-base">{profile && profile.linkedinusername}</p>
                  <Input placeholder="Enter LinkedIn username" name="linkedinusername" type="text" handleChange={(e) => setLinkedinusername(e.target.value)} />

                  <div className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#2546bd]" onClick={hundleSubmit}>
                    Update
                  </div>

                  <div className="h-[1px] w-full bg-gray-400 my-2" />
                </div>
              </div>
            </div>
          </div>
          <div className="gradient__bg pt-5 rounded">
            {profile && <GithubStats githubUsername={profile.githubusername} />}
          </div>
        </div>
      )
  );
};

export default Profile;
